/**
 * Validates application/display name and scope prefix with rules:
 * - Numbers allowed at start, but value cannot be only numbers (e.g. 12345 invalid, 1st-api-app valid)
 * - Only letters, numbers, hyphens (-), and underscores (_)
 * - Cannot start with hyphen or underscore
 *
 * @param value - The string to validate
 * @param fieldLabel - Optional label for error messages (e.g. "Display name", "Application name"). Defaults to "Name".
 * @returns Empty string if valid, otherwise the specific error message
 */
export function getApplicationNameValidationError(
  value: string,
  fieldLabel: string = "Name"
): string {
  if (!value) return "";
  if (/^[-_]/.test(value)) {
    return `${fieldLabel} cannot start with a hyphen or underscore.`;
  }
  if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
    return `${fieldLabel} can only contain letters, numbers, hyphens, and underscores.`;
  }
  if (/^[0-9]+$/.test(value)) {
    return `${fieldLabel} cannot contain only numbers. It must include at least one letter.`;
  }
  return "";
}
